/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SnippetParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['key', codecString],
    ['value', codecString],
]);
export class Snippet extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SnippetParser.decode(input).map(res => new Snippet(res));
    }
    static unsafeDecode(input) {
        return Snippet.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SnippetParser.encode(data);
    }
    static schema() {
        return SnippetParser.schema();
    }
}
